class UsersController {
  constructor(User) {
    "ngInject";

    let vm = this;
    vm.users = [];
    vm.pagination = {
      page: 0,
      limit: 25
    }
    vm.init = init;
    vm.openUser = openUser;
    init();

    function init() {
      User.getList(vm.pagination.page, vm.pagination.limit).then(res => {
        vm.users = res.data;
      })
    }

    function openUser(user) {
      console.log("Apri dettagli utente:", user);
    }
  }
}

export default UsersController;



// WEBPACK FOOTER //
// ./client/app/components/dashboard/users/users.controller.js